import { createSlice, createSelector } from '@reduxjs/toolkit';
import { EMPLOYEETYPES_CODE } from 'Chores/Constants';

export const requestsSlice = createSlice({
  name: 'requests',
  initialState: {
    users: [],
    projects: [],
    roles: [],
    scrumTeams: [],
    currentUserInfo: {},
    approverGroups: []
  },
  reducers: {
    setUsers: (state, action) => {
      state['users'] = action.payload;
    },
    setProjects: (state, action) => {
      state['projects'] = action.payload;
    },
    setRoles: (state, action) => {
      state['roles'] = action.payload;
    },
    setScrumTeams: (state, action) => {
      state['scrumTeams'] = action.payload;
    },
    setCurrentUserInfo: (state, action) => {
      state['currentUserInfo'] = action.payload;
    },
    setMyApprovalTaskCount: (state, action) => {
      state['myApprovalTaskCount'] = action.payload;
    },
    setApproverGroups: (state, action) => {
      state['approverGroups'] = action.payload;
    }
  }
});

export const { setUsers, setProjects, setRoles, setScrumTeams, setCurrentUserInfo, setApproverGroups } =
  requestsSlice.actions;

export const selectActiveProjects = createSelector((state) => state.requests.projects, (projects) =>
  projects?.filter((project) => project.isActive)
);

export const selectCWEAndFTEUser = createSelector((state) => state.requests.users, (users) => users?.filter((user) =>
  user.employeeType === EMPLOYEETYPES_CODE.CWE || user.employeeType === EMPLOYEETYPES_CODE.FTE));

export const selectAllUsers = (state) => state.requests.users;

export default requestsSlice.reducer;
